<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconMinus_16"
    viewBox="0 0 16 16"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        fill-rule="evenodd"
        d="M13.325 8a.8.8 0 0 1-.8.8h-9.05a.8.8 0 0 1 0-1.6h9.05a.8.8 0 0 1 .8.8Z"
        clip-rule="evenodd"
    />
</svg>
